/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FilePowerpoint32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <g fill="none">
            <path
                fill="#C43E1C"
                d="M9 3h9.586c.265 0 .52.105.707.293l6.415 6.414a1 1 0 01.293.707V26A3.002 3.002 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z"
            />
            <path
                fill="#E19E8D"
                d="M19.286 3.286l6.422 6.421a.994.994 0 01.203.293H21a2.001 2.001 0 01-1.995-1.85L19 8V3.09c.105.048.202.114.286.196z"
            />
            <path
                fill={vars.white}
                d="M16 24a5.947 5.947 0 004.239-1.76 6.07 6.07 0 00.94-1.214c.262-.443.465-.92.607-1.432A5.862 5.862 0 0022 18a5.947 5.947 0 00-1.76-4.239 6.07 6.07 0 00-1.214-.94 5.894 5.894 0 00-1.432-.607A5.862 5.862 0 0016 12c-.457 0-.904.05-1.342.152a6.123 6.123 0 00-1.257.44c-.4.191-.776.427-1.128.706-.351.28-.67.597-.955.952h-.568A.748.748 0 0010 15v6a.748.748 0 00.75.75h.568c.286.355.604.673.955.952.352.28.728.515 1.128.706.4.192.82.338 1.257.44.438.101.885.152 1.342.152zm0-9.75h-3.668A5.186 5.186 0 0116 12.75v1.5zm5.197 3H17.5V15a.73.73 0 00-.219-.527.847.847 0 00-.241-.161.703.703 0 00-.29-.062v-1.447a5.086 5.086 0 011.617.512c.504.26.951.585 1.342.976.39.39.716.838.976 1.342.26.504.43 1.043.512 1.617zm-7.869 3.188h-1.213v-4.875h1.887c.258 0 .495.03.712.093.217.063.402.16.557.29.154.131.275.297.363.498.088.202.132.439.132.712 0 .266-.047.503-.141.712-.094.21-.223.386-.387.53a1.688 1.688 0 01-.577.331c-.22.077-.458.115-.712.115h-.62v1.593zm.527-2.655c.207 0 .369-.043.484-.129.115-.086.173-.24.173-.463 0-.214-.056-.36-.167-.439-.112-.078-.267-.117-.466-.117h-.55v1.148h.526zM16 23.25a5.186 5.186 0 01-3.668-1.5h4.418a.748.748 0 00.75-.75v-3.006h3.75c0 .485-.063.95-.188 1.395a5.251 5.251 0 01-1.353 2.32 5.258 5.258 0 01-2.317 1.353A5.155 5.155 0 0116 23.25z"
            />
        </g>
    </AccessibleSVG>
);

export default FilePowerpoint32;
